/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
import stringify from 'fast-safe-stringify';

export const parsePage = <T>(page: unknown): T =>
    // Kill circular references
    JSON.parse(stringify(page)) as T;
